import { useCallback, useMemo, useState } from "react";
import { isIOS } from "utilities/src/platform";
const MIN_WIDTH = isIOS ? 44 : 48;
const MIN_HEIGHT = MIN_WIDTH;
export const getHitSlop = ({ width, height }) => {
  const additionalWidth = width < MIN_WIDTH ? MIN_WIDTH - width : 0;
  const additionalHeight = height < MIN_HEIGHT ? MIN_HEIGHT - height : 0;
  if (additionalWidth === 0 && additionalHeight === 0) {
    return void 0;
  }
  return {
    top: additionalHeight / 2,
    right: additionalWidth / 2,
    bottom: additionalHeight / 2,
    left: additionalWidth / 2
  };
};
export const useAutoHitSlop = (onLayoutArg) => {
  const [frameSize, setFrameSize] = useState(void 0);
  const onLayout = useCallback(
    (event) => {
      onLayoutArg?.(event);
      const {
        nativeEvent: { layout }
      } = event;
      setFrameSize((prevFrameSize) => {
        if (!prevFrameSize || layout.width !== prevFrameSize.width || layout.height !== prevFrameSize.height) {
          return { width: layout.width, height: layout.height };
        }
        return prevFrameSize;
      });
    },
    [onLayoutArg]
  );
  const finalHitSlop = useMemo(() => {
    if (!frameSize) {
      return void 0;
    }
    return getHitSlop(frameSize);
  }, [frameSize]);
  return [finalHitSlop, onLayout];
};
